import { getItem } from 'utils/localStorage'
import envs, { EnvironmentName } from './envs'

const ensureValidAppEnv = (
  env: EnvironmentName = 'production'
): EnvironmentName => {
  return envs[env] ? env : 'production'
}

const getCurrentEnv = (): EnvironmentName => {
  if (process.env.REACT_APP_ENV === 'production') {
    return 'production'
  }

  const appEnv = getItem('app_env') as EnvironmentName
  if (appEnv) {
    console.warn(`Using '${appEnv}' environment from local storage.`)
    console.warn(`Use localStorage.removeItem('app_env') to reset.`)
    return ensureValidAppEnv(appEnv)
  }

  return ensureValidAppEnv(process.env.REACT_APP_ENV as EnvironmentName)
}

export const CURRENT_ENV = getCurrentEnv()

// Utility to check if the current frontend built is running on staging environment (intended to be released on staging.sketch.cloud)
export const isDeployedInStaging = () =>
  (process.env.REACT_APP_ENV as EnvironmentName) === 'staging' &&
  process.env.NODE_ENV === 'production'

// Utility to check if the current frontend built is production ready (intended to be released on www.sketch.cloud)
export const isDeployedInProduction = () =>
  (process.env.REACT_APP_ENV as EnvironmentName) === 'production' &&
  process.env.NODE_ENV === 'production'

// Utility to check if the current target (backend) environment is the production environment.
export const isProduction = () => CURRENT_ENV === 'production'

export default envs[CURRENT_ENV]
